import React, { memo } from 'react';
import { getComboText } from '../game/scoring';

function ScoreDisplay({ score, highScore, combo }) {
  const comboText = getComboText(combo);

  return (
    <div className="score-display">
      <div className="score-section">
        <div className="score-label">SCORE</div>
        <div className="score-value" aria-live="polite" aria-atomic="true">
          {score.toLocaleString()}
        </div>
      </div>

      <div className="score-section score-section-best">
        <div className="score-label">BEST</div>
        <div className="score-value score-value-best">
          {highScore.toLocaleString()}
        </div>
      </div>

      {score === 0 && !comboText && (
        <div className="score-hint">Clear lines to score</div>
      )}

      {comboText && (
        <div className="combo-display" key={combo} aria-live="assertive">
          {comboText}
        </div>
      )}
    </div>
  );
}

export default memo(ScoreDisplay);
